import * as React from 'react';
import FormControlContext, { FormControlState } from './FormControlContext';

export default function useFormControlContext<T = FormControlState>() {
  return React.useContext(FormControlContext as unknown as React.Context<T>);
}
